import logo from "./logo.svg";
import "./App.css";
// import Analysis from "./view/analysis/Analysis";
// import Details from "./view/details/Details";
import BrandSpecial from "./view/categoryCustom/category/BrandSpecial";
import CustomAnalysisIndex from "./view/customAnalysis/CustomAnalysisIndex";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
  useOutlet,
} from "react-router-dom";
import routes from "./router/index";
import {KeepAlive} from "react-activation";
import React, { Suspense } from "react";
// function Layout() {
//   const outlet = useOutlet();
  
//   return (
//     <div>
//       <KeepAlive cacheKey="main-content">
//         {outlet}
//       </KeepAlive>
//     </div>
//   );
// }

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/analysis" replace />}>
          </Route> */}
          {routes.map((routers, index) =>
            (routers.children && routers.children.length >= 1) ? (
              routers.children.map((routes2, index2) => (
                <Route
                  key={index2}
                  exact
                  path={routes2.path}
                  element={routes2.id === "BrandSpecial" ? <KeepAlive id={routes2.id}><BrandSpecial /></KeepAlive>  : routes2.id === "CustomAnalysisIndex" ? <KeepAlive id={routes2.id}><CustomAnalysisIndex /></KeepAlive>: <routes2.component />}
                />
              ))
            ) : (
              <Route
                key={index}
                exact
                path={routers.path}
                element={<routers.component />}
              />
            )
          )}
        </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
